/**
 * Blog CTA Positioning Script
 * Handles dynamic CTA placement based on section IDs
 */

document.addEventListener('DOMContentLoaded', function() {
  positionCTASections();
});

function positionCTASections() {
  const ctaTemplate = document.querySelector('[data-cta-section]');
  const blogContent = document.querySelector('.text-rich-text-v2.blog_post-body');
  
  if (!ctaTemplate || !blogContent) {
    console.warn('CTA template or blog content not found');
    return;
  }
  
  // Get positions from data attribute (can be comma-separated)
  const positionsAttr = ctaTemplate.getAttribute('data-cta-position');
  
  if (!positionsAttr) {
    // Default: append at the end of blog content
    blogContent.appendChild(ctaTemplate);
    showCTA(ctaTemplate);
    return;
  }
  
  // Split multiple positions and remove whitespace
  const positions = positionsAttr.split(',').map(p => p.trim()).filter(p => p);
  
  if (positions.length === 0) {
    blogContent.appendChild(ctaTemplate);
    showCTA(ctaTemplate);
    return;
  }
  
  // If multiple positions, clone the CTA for each position
  positions.forEach((position, index) => {
    let ctaElement;
    
    if (index === 0) {
      // Use original element for first position
      ctaElement = ctaTemplate;
    } else {
      // Clone for additional positions
      ctaElement = ctaTemplate.cloneNode(true);
      ctaElement.setAttribute('data-cta-clone', index);
      ctaElement.removeAttribute('data-cta-section');
    }
    
    insertCTAAtPosition(ctaElement, position, blogContent);
    showCTA(ctaElement);
  });
}

function showCTA(ctaElement) {
  ctaElement.style.display = 'flex';
}

function insertCTAAtPosition(ctaElement, position, blogContent) {
  
  // Handle 'at-start' or 'start' position
  if (position === 'at-start' || position === 'start') {
    blogContent.insertBefore(ctaElement, blogContent.firstChild);
    return;
  }
  
  // Handle 'at-end' or 'end' position
  if (position === 'at-end' || position === 'end' || position === '') {
    blogContent.appendChild(ctaElement);
    return;
  }
  
  // Handle 'after-section-X' positions
  if (position.startsWith('after-section-') || position.startsWith('after-')) {
    const sectionId = position.replace('after-', '');
    const targetSection = blogContent.querySelector(`#${sectionId}`);
    
    if (targetSection) {
      // console.log('Found target section:', targetSection);
      
      // Find the wrapper that contains this section
      // In your case: .blog_post-main or .text-rich-text-v2.w-richtext
      const sectionWrapper = targetSection.closest('.blog_post-main, .text-rich-text-v2.w-richtext');
      
      if (sectionWrapper) {
        // console.log('Found section wrapper:', sectionWrapper);
        
        // Now we need to insert INSIDE the wrapper, after the target section
        // Find the next section (h2, h3, etc.) or end of wrapper
        const nextSection = findNextSectionInWrapper(targetSection, sectionWrapper);
        
        if (nextSection) {
          // console.log('Found next section:', nextSection);
          // Insert before the next section
          sectionWrapper.insertBefore(ctaElement, nextSection);
        } else {
          // console.log('No next section, appending to wrapper');
          // No next section, append to end of wrapper
          sectionWrapper.appendChild(ctaElement);
        }
      } else {
        console.warn('Could not find section wrapper');
        // Fallback: insert after target section
        insertAfterElement(ctaElement, targetSection);
      }
      return;
    } else {
      console.warn(`Section with ID "${sectionId}" not found`);
    }
  }
  
  // Handle 'after-paragraph-X' positions
  if (position.startsWith('paragraph-') || position.startsWith('after-paragraph-')) {
    const paragraphNumber = parseInt(position.replace(/^(after-)?paragraph-/, ''));
    const paragraphs = blogContent.querySelectorAll('p');
    
    if (paragraphs[paragraphNumber - 1]) {
      const targetParagraph = paragraphs[paragraphNumber - 1];
      insertAfterElement(ctaElement, targetParagraph);
      return;
    } else {
      console.warn(`Paragraph ${paragraphNumber} not found`);
    }
  }
  
  // Default fallback: append at the end
  blogContent.appendChild(ctaElement);
}

/**
 * Find the next section heading within the same wrapper
 */
function findNextSectionInWrapper(currentSection, wrapper) {
  let nextElement = currentSection.nextElementSibling;
  const currentLevel = parseInt(currentSection.tagName.substring(1)); // Get h2 = 2, h3 = 3, etc.
  
  while (nextElement) {
    const tagName = nextElement.tagName;
    
    // Check if it's a heading of same or higher level
    if (tagName && tagName.match(/^H[1-6]$/)) {
      const nextLevel = parseInt(tagName.substring(1));
      
      // If same or higher level (e.g., h2 when looking for next after h2)
      if (nextLevel <= currentLevel) {
        return nextElement;
      }
    }
    
    nextElement = nextElement.nextElementSibling;
  }
  
  // No next section found
  return null;
}

function insertAfterElement(newElement, targetElement) {
  if (targetElement.nextSibling) {
    targetElement.parentNode.insertBefore(newElement, targetElement.nextSibling);
  } else {
    targetElement.parentNode.appendChild(newElement);
  }
}